export enum PurchasingPhaseENUM {
  QUOTATION = "QUOTATION",
  ON_APPROVAL = "ON_APPROVAL",
  PURCHASING = "PURCHASING",
  FINISHED = "FINISHED",
  ON_APPROVAL_RECEIPT = "ON_APPROVAL_RECEIPT",
  TOTALLY_COMPLETED = "TOTALLY_COMPLETED",
}
